import { Cog6ToothIcon } from "@heroicons/react/16/solid"
import { Link } from "react-router-dom"

/** Floating Setup entry that stays visible at any scroll depth — quiet glass
 * chip with an accent gear so it reads as chrome, not a CTA. Sits bottom-left,
 * clear of the section rail on the right. */
export function ProposalSetupFab({ to }: { to: string }): JSX.Element {
  return (
    <Link
      to={to}
      className="fixed bottom-6 left-6 z-20 flex items-center gap-2 rounded-full border border-bp-border bg-bp-page/85 px-4 py-2 text-[length:var(--step--1)] font-semibold text-bp-text-muted shadow-md backdrop-blur-xl hover:border-bp-border-strong hover:text-bp-text focus-visible:ring-2 focus-visible:ring-bp-accent focus-visible:outline-none print:hidden"
    >
      <Cog6ToothIcon className="size-4 text-bp-accent" />
      Setup
    </Link>
  )
}
